import {GatewayOrderType} from "./gatewayOrderType";

export class GatewayOrderCreateRequest {
  constructor(
    public environmentKey: string,
    public orderName: string,
    public gatewayOrderType: GatewayOrderType,
    public hubTenantName: string,
  ) {
  }
}
